import { useEffect } from 'react';
import { useRouter } from 'next/router';
import { useTranslation } from 'next-i18next';

import { useStorage } from 'hooks/useStorage';

const LANG_STORAGE_KEY = 'i18nextLng';

export const useLanguageSelect = () => {
  const { isReady, query } = useRouter();
  const { get, set } = useStorage();
  const { i18n } = useTranslation('common');

  async function changeLanguage(language: 'it' | 'en') {
    if (i18n.language === language) {
      return;
    }

    await i18n.changeLanguage(language);

    set(LANG_STORAGE_KEY, i18n.language);
  }

  useEffect(() => {
    if (!isReady) return;

    async function loadLanguage() {
      const langQuery = query.locale ?? query.lang;

      if (langQuery) {
        await i18n.changeLanguage(langQuery === 'en' ? 'en' : 'it');

        set(LANG_STORAGE_KEY, i18n.language);

        return;
      }

      const lang = get(LANG_STORAGE_KEY);

      if (!lang) {
        return;
      }

      await i18n.changeLanguage(JSON.parse(lang) || 'it');
    }

    loadLanguage();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isReady]);

  return {
    changeLanguage,
  };
};
